import React from 'react';
import { useIntl } from 'react-intl';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { getDashboardIcon } from '../../utils/utils';

import PaperCard from './paper-card';

const useStyles = makeStyles(theme => ({
  header: {
    color: 'rgb(182, 193, 220)',
    fontSize: 18, 
    padding: theme.spacing(1, 0, 3, 0),
    fontWeight: 600
  },
  subHeader: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    padding: theme.spacing(0, 0, 1, 0)
  },
  numberPercent: {
    color: 'rgb(2,206,178)'
  },
  height: {
    height: 400
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  boxParent: {
    display:'flex',
    flexDirection:'column', 
    justifyContent:'space-around',
    alignItems:'center'
  },
  darkMode: {
    color: '#000',
  }
}));

export default function OverallCard({className, theme}) {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const children = (
    <div className={classes.content}>
      <Typography variant="h6" component="p" className={classes.header}>
      {formatMessage({id:"app.subHeader.dashboard.overallfeeling", defaultMessage: "Overall feeling"})}
      </Typography>
      <Box p={2}>
      {!theme ?
        <img src={getDashboardIcon('overallSmiley')} alt="img" /> 
        : <img src={getDashboardIcon('overallDark')} alt='img'/>
      }
      </Box>
      <Box className={classes.boxParent}>
        <Typography variant="h2" component="p" classes={{root: clsx(classes.subHeader, !theme ? classes.darkMode : null)}}>
          Positive
        </Typography>
        <Typography variant="h3" component="p" className={classes.numberPercent}>
          84%
        </Typography>
      </Box>
    </div>
    )
  return (
    <PaperCard
      children={children}
      height={classes.height}
      theme={theme} 
    />
  );
}
